import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (_) { /* fall through */ }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response ? fallback : "Network error — check your connection and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0] || ""}: ${x.msg}`.replace(/^: /, "")).join(" · ");
  return d.msg || fallback;
}
